const getters = {
  mode(state) {
    return state.mode
  }
}

export default getters
